import { setGroup } from '@amplitude/analytics-browser'

type Groups = {
  company: string[]
}

export const assignAmplitudeGroup = <T extends keyof Groups>(
  groupName: T,
  groupValue: Groups[T]
) => {
  setGroup(groupName, groupValue)
}
